import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import {
  FilterValue,
  OpenedFilterTabByFilterKey,
} from "../../../components/_shared-components/generic-listing-page/types";
import { UITags } from "../../../components/_shared-components/ui-elements/UITags";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../components/T";

export const ActiveFiltersBar: ReactTFC<{
  fullActiveFacets: Array<{
    key: string;
    value: Array<string>;
    keyLabel: TranslatedValue | string;
    valueLabel: TranslatedValue | string;
  }>;
  filterRemovalRequested: (key: NonNullable<OpenedFilterTabByFilterKey>, value: FilterValue["value"]) => void;
}> = props => {
  const elements = props.fullActiveFacets.map(({ key, value, keyLabel, valueLabel }) => ({
    key: `${key}-${value.join(".")}`,
    onClick: () => props.filterRemovalRequested(key, value[0]!),
    label: (
      <>
        <T>{keyLabel}</T>:{" "}
        <span>
          <T>{valueLabel}</T>
        </span>
      </>
    ),
  }));

  return <UITags elements={elements} />;
};
